import { Injectable } from '@angular/core';
import type { TenantContext } from './auth.service';

interface SessionTokenPayload {
  permissions?: string[];
  typeTenant?: TenantContext;
  profileName?: string;
  userTenantUuid?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SessionPermissionService {
  private getPayload(): SessionTokenPayload | null {
    const accessToken = localStorage.getItem('access_token') ?? '';
    return this.parseTokenPayload(accessToken);
  }

  private parseTokenPayload(token: string): SessionTokenPayload | null {
    const tokenParts = token.split('.');

    if (tokenParts.length < 2) {
      return null;
    }

    try {
      const base64 = tokenParts[1].replace(/-/g, '+').replace(/_/g, '/');
      const normalized = base64.padEnd(
        base64.length + ((4 - (base64.length % 4)) % 4),
        '=',
      );
      const decoded = atob(normalized);
      const bytes = Uint8Array.from(decoded, (character) =>
        character.charCodeAt(0),
      );
      const json = new TextDecoder().decode(bytes);
      return JSON.parse(json) as SessionTokenPayload;
    } catch {
      return null;
    }
  }

  getPermissions(): string[] {
    const payload = this.getPayload();

    return payload?.permissions ?? [];
  }

  hasPermissionsClaim(): boolean {
    const payload = this.getPayload();
    return Array.isArray(payload?.permissions);
  }

  hasPermission(permission: string): boolean {
    return this.getPermissions().includes(permission);
  }

  getTypeTenant(): string | null {
    const payload = this.getPayload();

    return payload?.typeTenant ?? null;
  }

  getProfileName(): string | null {
    const payload = this.getPayload();

    return payload?.profileName ?? null;
  }

  getUserTenantUuid(): string | null {
    return this.getPayload()?.userTenantUuid ?? null;
  }
}
